module.exports = __webpack_public_path__ + "static/img/value-0.9271a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/value-0.png
// module id = ml9l
// module chunks = 1